<template>
  <div class="SCRM">
    <div class="page_img">
      <img src="@/assets/img/scrm_system.jpg" alt="">
    </div>
    <div class="page_content content flex_row">
      <div class="content_title summary_top">
        <img class="back_left" src="@/assets/img/scienceBorder_left.png" alt="">
        <img class="back_right" src="@/assets/img/scienceBorder_right.png" alt="">
        <div class="page_summary font_shadow">智能营销SCRM</div>
      </div>
    </div>
    <div class="page_main flex_column scrm_main">
      <img src="@/assets/img/scrm_main.png" alt="">
      <div class="main_explain scrm_explain">运营数据汇总成各种科学管理的不同维度的报告，辅助决策者对经营和发展做出实时调整，让企业的经营实现可持续发展的健康生态。</div>
      <img class="img2" src="@/assets/img/scrm_main1.png" alt="">
    </div>
    <div class="page_system flex_column system">
      <div class="sys_title flex_column system_title">
        <div class="sys_summary">眼健康中心运营三大要素 — 流量裂变</div>
        <div class="line_circle">
          <div class="line"></div>
          <div class="circle"></div>
        </div>
      </div>
      <div class="system_main1">
        <img src="@/assets/img/scrm.png" alt="">
      </div>
    </div>
    <bottom></bottom>
  </div>
</template>

<script>
import softTop from "@/components/pc/softTop";
import bottom from "@/components/pc/bottom";
export default {
  name: 'SCRM',
  components: {
    softTop,
    bottom
  },
  data() {
    return {
    }
  },
  created() {
  },
}
</script>

<style scoped lang="scss">
.SCRM {
  .content {
    margin-top: 0.4rem;
  }
  .scrm_main {
    margin: 1.5rem 0 1rem;
    img {
      width: 50%;
    }
    .img2 {
      width: 55%;
    }
    .scrm_explain {
      margin: 1rem 0 1rem;
      width: 65%;
      padding: 0.25rem 0.3rem;
      font-size: 0.19rem;
      font-weight: 500;
    }
  }
  .system {
    margin-bottom: 1.3rem;
    .system_title {
      .sys_summary {
        font-size: 0.3rem;
        text-align: center;
        font-weight: bold;
      }
    }
    .system_main1 {
      margin-top: 0.8rem;
      img {
        width: 50%;
      }
    }
  }

}
</style>
